import { Button, Result } from 'antd';
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * AccountDeactivated — the full-screen lock state (one-org model M2, multi_org_v2_prd.md rev 5).
 *
 * A member deactivated from their organization has their whole ACCOUNT locked: the backend auth
 * middleware rejects every API call with error_type=account_deactivated, and the shared axios
 * interceptor (services/auth/axiosConfig.js) routes here. This page deliberately makes NO API
 * calls — every one of them would be rejected anyway. Reactivation by an org admin is the only
 * way back in.
 */
const AccountDeactivated = () => {
  const { logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (e) {
      // Session teardown is best-effort — the account is locked server-side regardless.
    }
    window.location.assign('/login');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Result
        status="403"
        title="Your account has been deactivated"
        subTitle="Please contact your organization admin to reactivate your account."
        extra={
          <Button type="primary" onClick={handleSignOut}>
            Sign out
          </Button>
        }
      />
    </div>
  );
};

export default AccountDeactivated;
